import React from 'react';

export default function ArrowRight(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 19 12"
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
    >
      <path
        fill="currentColor"
        d="m17.754 6.848-4.781 4.78c-.352.352-.88.352-1.196 0-.351-.316-.351-.843 0-1.194l3.34-3.34H.844C.352 7.094 0 6.742 0 6.25c0-.457.352-.844.844-.844h14.273l-3.34-3.34c-.351-.316-.351-.843 0-1.195.317-.316.844-.316 1.196 0l4.78 4.816a.828.828 0 0 1 0 1.16Z"
      />
    </svg>
  );
}
